export default __webpack_public_path__ + "static/media/bg-image.ed597cee.webp";